import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ENVIRONMENT } from '@shared/injection-token/environment';
import { Environment } from '@shared/interfaces/environment';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  readonly environment: Environment;

  constructor(
    private meta: Meta,
    private title: Title
  ) {
    this.environment = inject(ENVIRONMENT);

    if (!this.environment.production) {
      this.addMetas(`robots`, `noindex`);
    }
  }

  addMetas(name: string, value: string) {
    this.meta.addTag({ name: name, content: value });
  }

  addTitle(title: string) {
    this.title.setTitle(title);
  }
}
